import styled from'styled-components';const PageTitle = styled.h1.withConfig({
  componentId: "sc-18eps6t-0"
})(["", ""], props => props.theme.typography.pageTitle);
const Subtitle = styled.h2.withConfig({
  componentId: "sc-18eps6t-1"
})(["", ""], props => props.theme.typography.subtitle);
const SectionTitle = styled.span.withConfig({
  componentId: "sc-18eps6t-2"
})(["", ""], props => props.theme.typography.sectionTitle);
const ButtonText = styled.span.withConfig({
  componentId: "sc-18eps6t-3"
})(["", ""], props => props.theme.typography.buttonText);
const BodyHighlight = styled.span.withConfig({
  componentId: "sc-18eps6t-4"
})(["", ""], props => props.theme.typography.bodyHighlight);
const Body = styled.span.withConfig({
  componentId: "sc-18eps6t-5"
})(["", ""], props => props.theme.typography.body);
const DescriptionMedium = styled.span.withConfig({
  componentId: "sc-18eps6t-6"
})(["", ""], props => props.theme.typography.descriptionMedium);
const Description = styled.span.withConfig({
  componentId: "sc-18eps6t-7"
})(["", ""], props => props.theme.typography.description);
const LabelMedium = styled.span.withConfig({
  componentId: "sc-18eps6t-8"
})(["", ""], props => props.theme.typography.labelMedium);
const Label = styled.span.withConfig({
  componentId: "sc-18eps6t-9"
})(["", ""], props => props.theme.typography.label);
const NotificationsNumbers = styled.span.withConfig({
  componentId: "sc-18eps6t-10"
})(["", ""], props => props.theme.typography.notificationsNumbers);export{Body,BodyHighlight,ButtonText,Description,DescriptionMedium,Label,LabelMedium,NotificationsNumbers,PageTitle,SectionTitle,Subtitle};//# sourceMappingURL=Typography.js.map
